import classNames from 'classnames';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Button from '../../Button';
import FileUploadError from '../../icons/FileUploadError';

import styles from '../FileUploader.module.scss';

const cx = classNames.bind(styles);

const Error = ({ className, title }) => {
  const fileUploaderClasses = cx(
    styles['file-uploader'],
    styles['file-uploader--with-subtitle'],
    styles['file-uploader--is-error'],
    className
  );

  return (
    <div className={fileUploaderClasses}>
      <div className={styles['file-uploader__row']}>
        <div className={styles['file-uploader__content']}>
          <div>
            <FileUploadError className={styles['file-uploader__icon']} />
          </div>
          <div className={styles['file-uploader__text-container']}>
            <div className={styles['file-uploader__title']}>{title}</div>
          </div>
        </div>
        <div>
          <Button disabled className={styles['file-uploader__button']}>
            {trans('document-upload.browse')}
          </Button>
        </div>
      </div>
      <div className={styles['file-uploader__row']}>
        <div className={styles['file-uploader__subtitle']}>
          {trans('document-upload.error')}
        </div>
      </div>
    </div>
  );
};

Error.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired
};

export default Error;
